







































import { Component, Vue, Watch } from 'vue-property-decorator'
import { PictureBookController, SchoolController } from '@/services/request.service'

@Component
export default class MIBP extends Vue {
  private loading = false
  private pictureBookData: Array<any> = []

  private get locale(): string {
    return this.$store.state.locale
  }

  private get pictureBookHeader(): Array<any> {
    return [
      {
        title: this.$t('mibp.pictureBook'),
        width: '30%',
        align: 'center',
        scopedSlots: {
          customRender: 'cover',
        },
      },
      {
        title: this.$t('mibp.suitableSection'),
        dataIndex: 'targetSection',
        width: '20%',
        align: 'center',
      },
      {
        title: this.$t('mibp.bookNum'),
        dataIndex: 'num',
        width: '20%',
        align: 'center',
      },
      {
        title: this.$t('common.operations'),
        width: '20%',
        align: 'center',
        scopedSlots: {
          customRender: 'operations',
        },
      },
    ]
  }

  private get isChildRoute(): boolean {
    return this.$route.name !== 'mibp'
  }

  private created(): void {
    this.getBookSeriesList()
  }

  private getBookSeriesList(): void {
    PictureBookController.getPictureBundleList()
      .then(res => {
        this.pictureBookData = res.data
      })
      .catch(err => {
        console.warn(err)
      })
  }

  private viewBundle(record): void {
    const { bundleId, enName, name, num, targetSection } = record
    this.$router
      .push({
        name: 'mibpDetail',
        params: { bundleId },
        query: { enName, name, num, targetSection },
      })
      .catch(err => {})
  }

  private viewSubscribe(record): void {
    const { bundleId, enName, name, num, targetSection } = record
    this.$router
      .push({
        name: 'mibpSubscribe',
        params: { bundleId },
        query: { enName, name, num, targetSection },
      })
      .catch(err => {})
  }
}
